import React, { Component } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';

class StaticTable extends Component {
	constructor(props) {
		super(props);
		this.state = {
			gridApi: null,
		};
		this.gridRef = React.createRef();
	}

	gridOptions = () => {
		const { data } = this.props;
		return {
			modules: AllModules,
			columnDefs: data.columnDefs,
			cacheBlockSize: 200,
			maxBlocksInCache: 6,
			enableColResize: true,
			enableSorting: true,
			enableFilter: true,
			rowHeight: 35,
			rowModelType: 'serverSide',
			maxConcurrentDatasourceRequests: 1,
			multiSortKey: 'ctrl',
			enableRangeSelection: true,
			suppressCutToClipboard: true,
		};
	};

	defaultColDefs = {
		flex: 1,
		minWidth: 100,
		resizable: true,
		editable: false,
		sortable: true,
	};

	render() {
		const { data, width, height } = this.props;

		return (
			<>
				<div
					style={{ height: height + 'px', width: width }}
					className="ag-theme-balham"
				>
					<AgGridReact
						ref={this.gridRef}
						modules={AllModules}
						columnDefs={data.columnDefs}
						cacheBlockSize={200}
						defaultColDef={this.defaultColDefs}
						maxBlocksInCache={6}
						onCellValueChanged={this.handleCellValueChange}
						rowModelType="clientSide"
						maxConcurrentDatasourceRequests={1}
						multiSortKey="ctrl"
						onGridReady={this.onGridReady}
						suppressCutToClipboard={true}
						suppressCellFocus={true}
						rowData={data.rowData}
					/>
				</div>
			</>
		);
	}
}

export default StaticTable;
